var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGasPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 14.2C38 13.8 38.5 13.5 38.8 13.8C58.6 33.4 61.7 41.6 61.3 52.5C61 62.3 51.7 71.3 41.6 71.3C31.5 71.3 23.3 63.5 23.6 54.4C24.3 33.7 39.7 30.8 38 14.2Z",
    fill: "#FEDC5D",
    stroke: "#FEDC5D",
    strokeWidth: 1.0902,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 35.2C51.8 46.8 53.7 51.6 53.4 57.9C53.2 63.5 47.9 68.5999 42.1 68.5999C36.3 68.5999 31.6 64.2 31.8 58.9C32.3 46.8 41.6 45.4 40 35.2Z",
    fill: "#FF931E",
    stroke: "#FF931E",
    strokeWidth: 0.9085,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasPrimary);
export default __webpack_public_path__ + "static/media/gas-primary.0f19774a91f1c986c06dfb5a8f26e4dd.svg";
export { ForwardRef as ReactComponent };